import { useEffect } from 'react';

/**
 * Scroll-Parallax für Sektionen.
 * Elemente mit data-parallax-bg innerhalb von [data-parallax] verschieben
 * sich beim Scrollen leicht gegensinnig (Hintergrund bewegt sich langsamer).
 * Deaktiviert bei prefers-reduced-motion.
 */
export function useScrollParallax() {
  useEffect(() => {
    const noMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (noMotion) return;

    let ticking = false;
    let rafId: number;

    const update = () => {
      const vh = window.innerHeight;
      document.querySelectorAll<HTMLElement>('[data-parallax-bg]').forEach(bg => {
        const parent = bg.closest<HTMLElement>('[data-parallax]');
        if (!parent) return;
        const rect = parent.getBoundingClientRect();
        // progress: 1 = section just entering from bottom, 0 = centered, -1 = exited top
        const progress = (rect.top + rect.height / 2 - vh / 2) / vh;
        const ty = Math.max(-40, Math.min(40, progress * 55));
        bg.style.transform = `translateY(${ty}px) scale(1.12)`;
      });
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        rafId = requestAnimationFrame(update);
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    update();

    return () => {
      window.removeEventListener('scroll', onScroll);
      cancelAnimationFrame(rafId);
    };
  }, []);
}
